import React from 'react';
import { Flex, FullHeight, Loader } from '@marvelapp/ui';
/** @param {any} */
export default function FullScreenLoader(_a) {
    var bg = _a.bg;
    return (React.createElement(FullHeight, null,
        React.createElement(Flex, { alignItems: "center", bg: bg, justifyContent: "center", minHeight: "100%", width: "100%" },
            React.createElement(Loader, { size: 24, testId: "full-screen-loader" }))));
}
